import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-ticker-tape',
  templateUrl: './ticker-tape.component.html',
  styleUrls: ['./ticker-tape.component.scss']
})
export class TickerTapeComponent implements OnInit {

  @Input() items: string[] = [];
  @Input() speed: number; // Speed in seconds

  get animationDuration() {
    return `${this.speed}s`;
  }

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit(): void {
  }

  // ngAfterViewInit(): void {
  //   const tickerContent = this.el.nativeElement.querySelector('.ticker-tape-content');
  //   const containerWidth = this.el.nativeElement.querySelector('.ticker-tape-container').offsetWidth;
  //   const tickerWidth = tickerContent.scrollWidth;
  //   const totalWidth = tickerWidth + containerWidth;
  //   const animationDuration = totalWidth / this.speed;

  //   this.renderer.setStyle(tickerContent, 'animation-duration', `${animationDuration}s`);
  // }

}
